<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Add Vehicle Emissions</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="spinner" *ngIf="!dataLoaded"></div>
    <ng-container *ngIf="dataLoaded">
        <form [formGroup]="form">
            <fieldset>
                <div class="row">
                    <div class="col-sm-12 mvd_form-group">
                        <label class="mvd_label--inline">
                            <input type="checkbox" #commutesToNonAttainmentArea name="commutesToNonAttainmentArea" (click)="setCommuteToNonAttainmentArea(commutesToNonAttainmentArea.checked)" /> Commutes to Non-Attainment Area
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 mvd_form-group">
                        <label [ngClass]="{'required':showAttainmentRequired()}" [attr.title]="showRequired() ? '* Required' : null" for="nonAttainmentArea">Non-Attainment Area</label>
                        <select class="mvd_form-control" id="nonAttainmentArea" (change)="onTestAreaChange($event.target.value)" formControlName="emissionAreaType" (blur)="calculateExpirationDate()">
                            <option [ngValue]="null">- Select -</option>
                            <option *ngFor="let e of getEmissionAreaTypes()" value="{{e.id}}">{{e.displayValue}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 mvd_form-group">
                        <label [ngClass]="{'required':showRequired()}" [attr.title]="showRequired() ? '* Required' : null" for="testType">Test Type</label>
                        <select class="mvd_form-control" id="testType" (change)="onTestTypeChange($event.target.value)" (blur)="calculateExpirationDate()" formControlName="testType">
                            <option [ngValue]="null">- Select -</option>
                            <option *ngFor="let e of getFilteredTestTypes()" value="{{e.id}}">{{e.displayValue}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 mvd_form-group">
                        <label for="isInitialTest">Initial Test?</label>
                        <input id="isInitialTest" type="checkbox" formControlName="initialTest"/>
                    </div>
                    <div class="col-md-3 mvd_form-group">
                        <label [ngClass]="{'required':showRequired()}" [attr.title]="showRequired() ? '* Required' : null" for="initialTestDate">Initial Test Date</label>
                        <p-calendar [showIcon]="true" (onSelect)="onInitialTestDateChanged($event)" (onInput)="onInitialTestDateInput($event)" formControlName="initialTestDate" (onBlur)="calculateExpirationDate()"></p-calendar>
                        <control-validation-messages control="initialTestDate"></control-validation-messages>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 mvd_form-group">
                        <label [ngClass]="{'required':showRequired()}" [attr.title]="showRequired() ? '* Required' : null" for="testResult">Test Result</label>
                        <select class="mvd_form-control" id="testResult" (change)="onTestResultChange($event.target.value)" (blur)="calculateExpirationDate()" formControlName="testResultType">
                            <option [ngValue]="null">- Select -</option>
                            <option *ngFor="let e of getFilteredResultTypes()" value="{{e.id}}">{{e.displayValue}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 mvd_form-group">
                        <label [ngClass]="{'required':showRequired()}" [attr.title]="showRequired() ? '* Required' : null" for="certificateType">Certificate Type</label>
                        <select class="mvd_form-control" id="certificateType" (change)="onCertificateTypeChange($event.target.value)" (blur)="calculateExpirationDate()" formControlName="certificateType">
                            <option value="0">- Select -</option>
                            <option *ngFor="let e of getFilteredEmissionCertificateTypes()" value="{{e.id}}">{{e.displayValue}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 mvd_form-group">
                        <label [ngClass]="{'required':showRequired()}" [attr.title]="showRequired() ? '* Required' : null" for="passedDate">Passed Date</label>
                        <p-calendar [showIcon]="true" (onSelect)="onTestPassedDateChanged($event)" (onInput)="onTestPassedDateInput($event)" formControlName="passedDate" (onBlur)="calculateExpirationDate()"></p-calendar>
                        <control-validation-messages control="passedDate"></control-validation-messages>
                    </div>
                    <div class="col-md-3 mvd_form-group">
                        <label for="expirationDate">Expiration Date</label>
                        <p-calendar [showIcon]="emissions.emissionCertificateTypeID === 20" formControlName="expirationDate" (onInput)="onExpirationDateInput()" (onBlur)="onExpirationDateInput()"></p-calendar>
                    </div>
                </div>
            </fieldset>

            <div class="modal-footer">
                <div class="btn--group">
                    <button type="button" class="btn--default" (click)="cancel()">Cancel</button>
                    <button class="btn--primary" type="submit" (click)="save()">Save</button>
                </div>
            </div>
        </form>
    </ng-container>

</div>


